(function () {
  if (window.JanelaCartCountSync) return;

  var syncTimer;
  var syncSequence = 0;
  var cartMutationPattern = /\/cart\/(add|change|update|clear)(\.js)?$/;

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartMutation(input) {
    var requestUrl = getRequestUrl(input);
    if (!requestUrl) return false;

    try {
      var url = new URL(requestUrl, window.location.origin);
      return url.origin === window.location.origin && cartMutationPattern.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function updateCartBadges(itemCount) {
    var countText = itemCount < 100 ? String(itemCount) : '99+';

    document.querySelectorAll('m-cart-count').forEach(function (badge) {
      badge.textContent = countText;
      badge.classList.toggle('m:hidden', itemCount === 0);
    });

    document.querySelectorAll('.m-cart-icon-bubble').forEach(function (cartLink) {
      var currentLabel = cartLink.getAttribute('aria-label') || '';
      var baseLabel = currentLabel.replace(/\s*\(\d+\+?\)\s*$/, '');
      var updatedLabel = itemCount > 0 ? baseLabel + ' (' + itemCount + ')' : baseLabel;
      var visuallyHiddenLabel = cartLink.querySelector('[class~="m:visually-hidden"]');

      cartLink.setAttribute('aria-label', updatedLabel);
      if (visuallyHiddenLabel) visuallyHiddenLabel.textContent = updatedLabel;
    });
  }

  async function syncCartCount() {
    var sequence = ++syncSequence;
    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    try {
      var response = await window.fetch(rootUrl + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      var cart = await response.json();
      if (sequence !== syncSequence || typeof cart.item_count !== 'number') return;

      updateCartBadges(cart.item_count);
    } catch (error) {
      // Keep cart actions non-blocking if the count refresh request fails.
    }
  }

  function scheduleCartCountSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCartCount, 100);
  }

  function observeFetch() {
    if (!window.fetch) return;

    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var cartMutation = isCartMutation(input);
      var request = originalFetch.apply(this, arguments);

      if (cartMutation) {
        request
          .then(function (response) {
            if (response && response.ok) scheduleCartCountSync();
          })
          .catch(function () {});
      }

      return request;
    };
  }

  function observeXmlHttpRequest() {
    if (!window.XMLHttpRequest) return;

    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.janelaCartMutation = isCartMutation(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.janelaCartMutation) {
        this.addEventListener(
          'load',
          function () {
            if (this.status >= 200 && this.status < 400) scheduleCartCountSync();
          },
          { once: true }
        );
      }

      return originalSend.apply(this, arguments);
    };
  }

  window.JanelaCartCountSync = {
    refresh: scheduleCartCountSync,
  };

  observeFetch();
  observeXmlHttpRequest();
})();
